module.exports = __webpack_public_path__ + "images/help_v2/video-tower-8e4e483f24cec85a3a7f06d837217fb5.jpg";